function FourthPage () {
    return(
        <div className="w-[80%] mx-auto text-white mt-44 lg:mt-28">
            <div className="flex flex-col gap-6 justify-between items-center">
            <h1 className="max-w-[45rem] text-4xl sm:text-5xl font-extrabold sm:leading-tight text-white text-center">Buy and sell with the lowest fees in the industry</h1>
            <p className="text-gray-500 text-center max-w-[35rem]"> Trade your favorite assets instantly with ultra-low fees, fast execution, and total transparency built in.
  </p>
            <button className="text-[#B982FF]">Learn More →</button>
            </div>
        </div>
    )
}

export default FourthPage